import React from "react"
import Layout from "./../components/layout";
import SEO from "../components/seo"

const PrivacyPolicy = () => {
  return (
    <Layout className="page">
      <SEO title="Mabel Gago | Privacy Policy" />
      <div>
        <p>
          MANDOM CORP. (SINGAPORE) PTE LTD. (“the Company”) pledges to adhere
          strictly to laws and regulations relating to protection of personal
          information by means of promoting “A Code of Conduct” that the Company
          has adopted. The Company believes that it is its social responsibility
          as well as the basis of its business activities to protect personal
          information of customers, in order that the Company aims to provide a
          safety and comfortable lifestyle for the customers. The Company hereby
          adopts and observes its Privacy Policy.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>1. Privacy System</strong>
        </p>
        <p>
          The Company considers personal information of customers to be our
          important assets. Under the guidance of its officer in charge of
          import PrivacyPolicy from './privacy-policy';
protection of personal information, the Company arranges the system
          for Privacy Policy, and implements the protection of personal
          information and the training of employees concerning privacy.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>2. Handling of Personal Information</strong>{" "}
        </p>
        <p>
          In order to manage personal information appropriately, the Company
          follows Company rules in gathering, using and entrusting the handling
          of personal information to third party. Disposal of personal
          information shall also be carried out appropriately.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>3. Purpose of Use </strong>
        </p>
        <p>
          So that the Company may provide customers with better products and
          services, the Company makes use of personal information strictly
          within the terms of agreement obtained when conducting questionnaires,
          sample distribution, prize competitions, e-mail services, catalog
          sales as well as when receiving various consultations from customers.
          When gathering information, the purpose of use of such information is
          as clearly defined as possible and the scope of such information does
          not go beyond that which is required for the attainment of the
          purpose. If any necessity arises for the use of personal information
          beyond its initial purpose of use, the Company informs the customer
          about this new purpose prior to use and obtains consent of the
          customer.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>4. Shared Use</strong>
        </p>
        <p>
          The Company may share the use of the following personal information
          with its subsidiaries:
        </p>
        <p>
          1. Items of personal data that may be shared: Name, address, telephone
          number, e-mail address, product purchase history{" "}
        </p>
        <p>
          2. Purpose Questionnaire, product monitoring, campaign announcements,
          dispatch of products/prizes{" "}
        </p>
        <p>
          3. Name of person or corporation responsible for the management of
          personal information MANDOM CORP. (SINGAPORE) PTE LTD.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>5. Disclosure/Supply of Personal Information</strong>
        </p>
        <p>
          The Company will not disclose/supply personal information of customers
          to third parties without prior consent given by the customer
          concerned, unless there is some special circumstance such as legal
          obligation for disclosure.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>6. Security</strong>
        </p>
        <p>
          The Company adopts appropriate security measures to protect personal
          information of customer and prevent illegal access, loss, damage,
          tampering with or leaking of personal information. With regard access
          to databases containing personal information, the Company restricts
          the number of staff with authority of access and takes stringent
          measures in order to prevent illegitimate use of personal information
          by Company staff as well as external agents. Should any problems
          occurs, the Company takes speedy remedial action.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>
            7. Requests Concerning Personal Information from Customers
          </strong>
        </p>
        <p>
          Requests from customers to view, correct, delete and take other such
          action over their own personal information shall be dealt with
          accordingly by the Company’s support team. However, in order to
          prevent the leak of personal information to third parties, the request
          is handled only when the Company can confirm the identity of the
          customer.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>8. Personal Information of Minors</strong>
        </p>
        <p>
          The Company provides the same protection to personal information of
          minors as with adults. Provided however that, the consent of
          parents/guardians may be sought as necessary.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>9. Policy Statement</strong>
        </p>
        <p>
          The Company strictly complies with laws and regulations, and other
          relevant rules to protect personal information, and undertakes a
          continuous reform of its management system, including policies
          (including this Privacy Policy), organization, planning,
          implementation, inspection and review thereof to protect personal
          information.
        </p>
      </div>
    </Layout>
  )
}

export default PrivacyPolicy
